
/**
 * @name InternalTickets.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\InternalTickets.js
 */

//import { apiCall, getBaseDir } from './utils.js';

import TableBuilder from '../../table_builder.js';
import Swal from 'sweetalert2';
var moment = require('moment-timezone')
var getBaseDir = null, apiCall = null, getBranchNameFromId = null, getSecUsers = null, toggleNotificationState = null, escapeSingleQuotes = null, getInternalTicketCategoryType = null, getSecUsers = null, userHasRole = null;

$(function () {
    import('../../utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        getBranchNameFromId = utils.getBranchNameFromId;
        getSecUsers = utils.getSecUsers;
        toggleNotificationState = utils.toggleNotificationState;
        escapeSingleQuotes = utils.escapeSingleQuotes;
        getInternalTicketCategoryType = utils.getInternalTicketCategoryType;
        userHasRole = utils.userHasRole;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname === utils.getBaseDir() + 'chamados' || location.pathname === utils.getBaseDir() + 'feedbacks') {
            new FinancialInternalTickets(true, {
                getBaseDir: utils.getBaseDir,
                apiCall: utils.apiCall,
            }, location.pathname === utils.getBaseDir() + 'feedbacks');
        }
    });
});

class FinancialInternalTickets {
    constructor(onloadList = false, deps = {}, is_feedbacks_page = false) {

        this.deps = deps;
        let self = this;
        this.tableHandler = new TableBuilder({
            table: '#table-internal-tickets-list',
            tableBody: '.js-internal-tickets-registrations-table',
            data: [],
            rowsPerPage: parseInt($('.js-internal-tickets-per-page option:selected').val()),
            filter: false,
            maxPages: 0,
            customId: "CrudInternalTicketsHandler",
            tableRowRenderer: function (rowData) {
                return self.mountTableRow(rowData);
            },
            OnClickFirstPage: function () {
                self.fetchInternalTicketsList();
            },
            OnClickLastPage: function () {
                self.fetchInternalTicketsList();
            },
        });
        this.selectedStatus = '';
        this.selectedCategory = '';
        this.selectedNumber = '';
        this.onlyMyTickets = false;
        this.nameQuery = '';
        this.isFeedbackPage = is_feedbacks_page;
        this.activeUsers = [];

        getSecUsers(users => {
            //console.log('users', users);
            let html = '<option value="" selected disabled>-- Selecione --</option>';
            users.forEach(user => {
                if (user.ACTIVE == 'Y') {
                    html += `<option value="${user.LOGIN}">${user.LOGIN}</option>`;
                    self.activeUsers.push(user);
                }
            });
            $('.js-internal-tickets-registrations-requester').html(html);
            $('select[name="internal_tickets_create_user"]').html(html);
            $('select[name="courtesy_edit_requester"]').html(html);
        });

        if (this.isFeedbackPage) {
            $('.js-internal-tickets-change-category').addClass('d-none');
        }

        this.fetchInternalTicketsList();
        this.bindDomTableAndFilterEvents();
        this.bindDomEvents();
    }

    fetchInternalTicketsList() {
        let self = this;
        $(".js-internal-tickets-registrations-table").block(window._loader.loading);
        if (this.fetchRequest) {
            if (typeof this.fetchRequest.abort === 'function')
                this.fetchRequest.abort();
            this.fetchRequest = null;
        }
        this.fetchRequest = apiCall({
            method: 'GET',
            endpoint: 'api/v1/internal-tickets',
            data: {
                page: self.tableHandler.getCurrentPage(),
                recordsPerPage: parseInt($('.js-internal-tickets-per-page option:selected').val()),
                ...self.selectedBranch !== -1 ? { branchId: self.selectedBranch } : {},
                ...self.startDate !== null && self.endDate !== null ? { startDate: self.startDate, endDate: self.endDate } : {},
                ...self.selectedStatus !== '' ? { status: self.selectedStatus } : {},
                ...self.selectedCategory !== '' ? { category: self.selectedCategory } : {},
                ...self.selectedNumber !== '' ? { number: self.selectedNumber } : {},
                ...self.nameQuery !== '' ? { name: self.nameQuery } : {},
                ...self.onlyMyTickets ? { myTickets: self.onlyMyTickets } : {},
                ...self.isFeedbackPage ? { feedbacks: self.isFeedbackPage } : {}
            },
            successCallback: function (res) {
                $(".js-internal-tickets-registrations-table").unblock();
                if (!res.error) {
                    self.internalTicketsList = res.data;
                    self.internalTicketsTotal = res.total;
                    self.tableHandler.renderPage(self.tableHandler.getCurrentPage(), false, self.internalTicketsList, false, self.internalTicketsTotal);

                    if (res.administrativeNonResolvedTickets) {
                        if (res.administrativeNonResolvedTickets.administrative_open_tickets > 0) {
                            $('.js-internal-tickets-create-new').prop('disabled', true);
                            $('.js-internal-tickets-warning').html(`
                                <div class="alert alert-primary" role="alert">
                                    <b>ATENÇÃO:</b><br><br>

                                    Você possui ${res.administrativeNonResolvedTickets.administrative_open_tickets} chamados <b>não resolvidos</b> da Administração.<br><br>

                                    A criação de novos chamados está <b>BLOQUEADA</b> até a resolução de todos chamados administrativos.<br><br>

                                    Atenciosamente,<br>
                                    Diretoria.
                                </div>    
                            `);
                            $('.js-internal-tickets-warning').removeClass('d-none');
                        } else {
                            $('.js-internal-tickets-create-new').prop('disabled', false);
                            $('.js-internal-tickets-warning').addClass('d-none')
                        }
                    }
                } else {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })
                }
            },
            errorCallback: function (err) {
                $(".modal-edit-patient-dialog").unblock();
            }
        });
    }

    mountTableRow = (ticket) => {
        let row = `<tr class="js-internal-ticket-${ticket.ID}" style="${ticket.VISTO == 0 ? "background:yellow;" : ""}">
            <td data-label="ID">#${ticket.ID}</td>
            <td data-label="Filial">${ticket.FILIAL}</td>
            <td data-label="Título">${ticket.TITULO}${this.isFeedbackPage ? `<span class="badge badge-info ml-1">FEEDBACK</span>` : ''}<br /><small>Solicitado por ${ticket.SOLICITANTE} <i class="fas fa-comments"></i> ${ticket.TOTAL_RESPOSTAS} resposta(s)</small></td>
            ${!this.isFeedbackPage ? `<td data-label="Time responsável">${getInternalTicketCategoryType(ticket.CATEGORIA_ID)}</td>` : ''}
            <td data-label="Status">${this.getTicketStatusStyle(ticket.STATUS)}</td>
            <td data-label="Data ${this.isFeedbackPage ? 'do feedback' : 'de solicitação'}">${moment(ticket.DATA_SOLICITACAO).tz('America/Sao_Paulo').format('DD/MM/YYYY HH:mm:ss')}</td>
            <td data-label="Ações">
                <button class="btn btn-sm btn-primary js-edit-internal-ticket" data-tippy-content="Visualizar Chamado" data-info='${escapeSingleQuotes(JSON.stringify(ticket).replace(/"/g, '&quot;'))}'><i class="fas fa-eye"></i></button>
                <button class="btn btn-sm btn-primary js-internal-tickets-add-reply" data-tippy-content="Resposta rápida" data-info='${escapeSingleQuotes(JSON.stringify(ticket).replace(/"/g, '&quot;'))}'><i class="fas fa-reply"></i></button>
                <!-- marcar como resolvido -->
                ${ticket.STATUS !== 'RESOLVIDO' ? `<button class="btn btn-sm btn-success js-internal-tickets-mark-as-solved" data-info='${escapeSingleQuotes(JSON.stringify(ticket).replace(/"/g, '&quot;'))}'><i class="fas fa-check"></i></button>` : ''}
            </td>
        </tr>`;

        return row;
    }

    bindDomTableAndFilterEvents() {
        let self = this;
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-page-${self.tableHandler.getTableId()}`, function (e) {
            e.preventDefault();
            let pageId = $(this).text();
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchInternalTicketsList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-previous-page-${self.tableHandler.getTableId()}`, function (e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() - 1; //console.log('previous pageId', pageId);
            if (pageId <= 0)
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchInternalTicketsList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-next-page-${self.tableHandler.getTableId()}`, function (e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() + 1; //console.log('next pageId', pageId);
            if (pageId > self.tableHandler.getMaxPages())
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchInternalTicketsList();
        });

        // Detecta usuário mudando de filial para buscar paciente
        $('.js-internal-tickets-registrations-branches-selector').change(function () {
            self.selectedBranch = $(this).val();
            self.fetchInternalTicketsList();
        });

        // Detecta usuário configurando filtro de data de adesão
        $(document).on('change', '.js-internal-tickets-registrations-start-date-input', function (e) {
            self.startDate = $(this).val();
            if (self.startDate === '')
                self.startDate = null;
            self.fetchInternalTicketsList();
        });

        // Detecta usuário configurando filtro de data de adesão
        $(document).on('change', '.js-internal-tickets-registrations-end-date-input', function (e) {
            self.endDate = $(this).val();
            if (self.endDate === '')
                self.endDate = null;
            self.fetchInternalTicketsList();
        });

        $(document).on('change', '.js-internal-tickets-status-selector', function () {
            self.selectedStatus = $(this).val();
            self.fetchInternalTicketsList();
        });

        $(document).on('change', '.js-internal-tickets-category-selector', function () {
            self.selectedCategory = $(this).val();
            self.fetchInternalTicketsList();
        });

        $(document).on('click', '.js-internal-tickets-my-tickets-selector', function () {
            self.onlyMyTickets = $(this).is(':checked');
            self.fetchInternalTicketsList();
        });

        $(document).on('click', '.js-internal-tickets-mark-all-as-read', function () {
            Swal.fire({
                title: 'Confirmação',
                text: 'Tem certeza que deseja marcar todos os chamados como lidos?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, marcar todos como lidos',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    self.markAllAsRead();
                }
            });
        });

        let inputInterval = null;
        $(document).on('input', '.js-internal-tickets-number-filter', function () {
            // add debounce
            clearTimeout(inputInterval); // Clear the previous interval
            inputInterval = setTimeout(() => {
                self.selectedNumber = $(this).val();
                self.fetchInternalTicketsList();
            }, 500);
        });

        $(document).on('input', '.js-internal-tickets-name-filter', function () {
            // add debounce
            clearTimeout(inputInterval); // Clear the previous interval
            inputInterval = setTimeout(() => {
                self.nameQuery = $(this).val();
                self.fetchInternalTicketsList();
            }, 500);
        });

        // Detecta usuário configurando filtro qtd de registros por página
        $(document).on('change', '.js-internal-tickets-per-page', function () {
            self.tableHandler.setRowsPerPage(parseInt($(this).val()));
            self.tableHandler.setCurrentPage(1);
            self.fetchInternalTicketsList();
        });
    }

    bindDomEvents() {
        let self = this;
        // Detecta usuário clicando no botão de editar paciente
        $(document).on('click', '.js-edit-internal-ticket', function (e) {
            e.preventDefault();
            let ticketData = $(this).data('info');
            self.viewInternalTicket(ticketData);
        });

        if (self.isFeedbackPage) {
            $(document).on('change', '#internal_tickets_create_branch', function () {
                let selectedBranchId = $(this).val();
                console.log('selectedBranchId', selectedBranchId);

                let filterBranchActiveUsers = self.activeUsers.filter(user => user.FILIAL_ID.includes(selectedBranchId));
                console.log('filterBranchActiveUsers', filterBranchActiveUsers);

                let usersSelect = $('#internal_tickets_create_user');
                usersSelect.empty();
                usersSelect.append('<option value="" selected disabled>-- Selecione --</option>');
                filterBranchActiveUsers.forEach(user => {
                    usersSelect.append('<option value="' + user.LOGIN + '">' + user.LOGIN + '</option>');
                });
            });
        }

        // Detecta usuário clicando no botão de criar novo paciente
        $(document).on('submit', '.js-internal-tickets-create-form,.js-internal-feedbacks-create-form', function (e) {
            e.preventDefault();
            self.createInternalTicket();
        });

        $(document).on('submit', '.js-internal-ticket-edit-form', function (e) {
            e.preventDefault();
            self.updateInternalTicket();
        });

        $(document).on('click', '.js-internal-tickets-add-reply', function () {
            let ticket = $(this).data('info');
            if (ticket)
                self.currentTicketId = ticket.ID;
            //console.log('ticket', self.currentTicketId, ticket);
            self.viewInteralTicketReplyModal();
        });

        $(document).on('submit', '.js-internal-tickets-answer-form', function (e) {
            e.preventDefault();
            let data = new FormData(document.getElementsByClassName('js-internal-tickets-answer-form')[0]);
            data.append('ticketId', self.currentTicketId);
            self.answerInternalTicket(data);
        });

        $(document).on('click', '.js-internal-tickets-change-category', function () {
            $('#internal_tickets_change_category_id').val(self.currentTicketId);
            $('#modal-internal-tickets-change-category').modal('show');
            $('.js-internal-tickets-change-category-extra-info').addClass('d-none');
        });

        $(document).on('submit', '.js-internal-tickets-change-category-form', function (e) {
            e.preventDefault();
            let data = $(this).serializeArray();
            $(".js-internal-tickets-change-category-form").block(window._loader.loading);
            $('.js-internal-tickets-change-category-form').find('input[type="submit"]').prop('disabled', true);

            let teamList = $('#internal_tickets_change_category_category option:selected').data('teamlist');


            Swal.fire({
                title: 'Confirmação',
                html: 'O chamado será direcionado para o setor de <b>' + getInternalTicketCategoryType($('#internal_tickets_change_category_category option:selected').val()) + '</b>.<br><br>Responsáveis: <b>' + (teamList) + '</b>',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, alterar categoria',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    apiCall({
                        method: 'POST',
                        endpoint: 'api/v1/internal-tickets/change-category',
                        data: {
                            ticketId: self.currentTicketId,
                            categoryId: $("#internal_tickets_change_category_category option:selected").val()
                        },
                        successCallback: function (res) {
                            $('.js-internal-tickets-change-category-form').find('input[type="submit"]').prop('disabled', false);
                            $(".js-internal-tickets-change-category-form").unblock();
                            if (!res.error) {
                                window.toast({
                                    text: res.message
                                });
                                $('#modal-internal-tickets-change-category').modal('hide');
                                $('.js-internal-tickets-change-category-form').trigger('reset');
                                $('.js-internal-tickets-change-category-extra-info').addClass('d-none');
                                self.fetchInternalTicketsList();
                                self.ticketGetAnswers(self.currentTicketId);
                            } else {
                                window.toast({
                                    error: res.error,
                                    text: res.message
                                })
                            }
                        },
                        errorCallback: function (err) {
                            $('.js-internal-tickets-change-category-form').find('input[type="submit"]').prop('disabled', false);
                            $(".js-internal-tickets-change-category-form").unblock();
                        }
                    });
                } else {
                    $('.js-internal-tickets-change-category-form').find('input[type="submit"]').prop('disabled', false);
                    $(".js-internal-tickets-change-category-form").unblock();
                }
            });
        });

        $(document).on('click', '.js-internal-tickets-mark-as-solved', function () {
            let ticket = $(this).data('info');
            Swal.fire({
                title: 'Marcar chamado como resolvido',
                text: 'Tem certeza que deseja marcar este chamado como resolvido?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, marcar como resolvido',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    apiCall({
                        method: 'POST',
                        endpoint: 'api/v1/internal-tickets/mark-as-solved',
                        data: {
                            ticketId: ticket.ID
                        },
                        successCallback: function (res) {
                            if (!res.error) {
                                window.toast({
                                    text: res.message
                                });
                                self.fetchInternalTicketsList();
                            } else {
                                window.toast({
                                    error: res.error,
                                    text: res.message
                                })
                            }
                        },
                        errorCallback: function (err) {
                            $(".modal-edit-patient-dialog").unblock();
                        }
                    });
                }
            });
        });

        $(document).on('change', '#internal_tickets_create_type', function () {
            let selected = $(this).val();
            console.log('selected', selected);
            if (selected == '4') {
                $('.js-internal-tickets-create-extra-info').removeClass('d-none');
                $('.js-internal-tickets-create-extra-info').html(`
                    <div class="alert alert-warning">
                        <b>Assuntos que são tratados pelo Sistema TI:</b><br><br>

                        <ul class="list-group">
                            <li class="list-group-item">- Desbloqueio para assinaturas na Autentique;</li>
                            <li class="list-group-item">- Alteração da última testemunha de um contrato na Autentique;</li>
                            <li class="list-group-item">- Correção de contratos de PIT para PIM e vice-versa;</li>
                            <li class="list-group-item">- Correção de contratos que estão assinados na Autentique e bloqueados no sistema;</li>
                            <li class="list-group-item">- Complemento de 52 sessões (plano anual);</li>
                            <li class="list-group-item">- Correção de erros do TheQuiro;</li>
                            <li class="list-group-item">- Criação de usuários no TheQuiro;</li>
                            <li class="list-group-item">- Criação/Transferência de quiropraxistas no TheQuiro;</li>
                        </ul><br>

                        <strong>Atenção!</strong> Chamados para Sistema TI devem conter as seguintes informações:<br><br>

                        <ul class="list-group">
                            <li class="list-group-item">- Número do contrato, da agenda, dependendo de cada caso;</li>
                            <li class="list-group-item">- Nome completo do paciente, exatamente como registrado no sistema, sem abreviações ou partes do nome omitidas;</li>
                            <li class="list-group-item">- Valor de lançamento e desconto, caso necessário;</li>
                            <li class="list-group-item">- Prints e vídeos que demonstrem o problema ocorrido, incluindo os dados inseridos.</li>
                        </ul>

                        <br>Caso não seja possível fornecer essas informações, ou o assunto não for tratado pelo Sistema TI, o chamado será fechado e bloqueado para reabertura.<br><br>
                        Atenciosamente,<br>
                        Equipe de Suporte ao Sistema
                    </div>
                `);
            } else if (selected == '42') {
                /**
                 * chamados referentes a criação de usuários novos no conta azul.

na abertura do chamado é necessário seguir o seguinte padrão para que possa ser criado o usuário:

- informar a unidade para qual seja criado. 
- Informar Nome do Usuário.
- informar o e-mail do usuário.
- informar a função do usuário.

🟥*OBS: É NESCESSARIO INFORMAR UM E-MAIL POIS PARA A CRIAÇÃO SÓ É POSSIVEL COM E-MAIL VALIDO*.

Pois a pós a criação, a pessoa deve entrar no e-mail informado e habilitar a conta através do link enviado para o e-mail mencionado.
                 */
                $('.js-internal-tickets-create-extra-info').removeClass('d-none');
                $('.js-internal-tickets-create-extra-info').html(`
                    <div class="alert alert-warning">
                        <strong>Atenção!</strong> Chamados referentes a criação de usuários novos no conta azul devem seguir o seguinte padrão:<br><br>
                        <ul class="list-group">
                            <li class="list-group-item">- Informar a unidade para qual seja criado.</li>
                            <li class="list-group-item">- Informar Nome do Usuário.</li>
                            <li class="list-group-item">- Informar o e-mail do usuário.</li>
                            <li class="list-group-item">- Informar a função do usuário.</li>
                            <li class="list-group-item">⚠️ <strong>OBS: É NESCESSARIO INFORMAR UM E-MAIL POIS PARA A CRIAÇÃO SÓ É POSSIVEL COM E-MAIL VÁLIDO</strong>.</li>
                            <li class="list-group-item">Pois após a criação, a pessoa deve entrar no e-mail informado e habilitar a conta através do link enviado para o e-mail mencionado.</li>
                        </ul>
                        <br>
                        Atenciosamente,<br>
                        Equipe Financeiro
                    </div> 
                `);
            } else {
                $('.js-internal-tickets-create-extra-info').addClass('d-none');
            }
        });

        $(document).on('change', '#internal_tickets_change_category_category', function () {
            let selected = $(this).val();
            if (selected == '4') {
                $('.js-internal-tickets-change-category-extra-info').removeClass('d-none');
                $('.js-internal-tickets-change-category-extra-info').html(`
                    <div class="alert alert-warning">
                        <b>Assuntos que são tratados pelo Sistema TI:</b><br><br>

                        <ul class="list-group">
                            <li class="list-group-item">- Desbloqueio para assinaturas na Autentique;</li>
                            <li class="list-group-item">- Alteração da última testemunha de um contrato na Autentique;</li>
                            <li class="list-group-item">- Correção de contratos de PIT para PIM e vice-versa;</li>
                            <li class="list-group-item">- Correção de contratos que estão assinados na Autentique e bloqueados no sistema;</li>
                            <li class="list-group-item">- Complemento de 52 sessões (plano anual);</li>
                            <li class="list-group-item">- Correção de erros do TheQuiro;</li>
                            <li class="list-group-item">- Criação de usuários no TheQuiro;</li>
                            <li class="list-group-item">- Criação/Transferência de quiropraxistas no TheQuiro;</li>
                        </ul><br>

                        <strong>Atenção!</strong> Chamados para Sistema TI devem conter as seguintes informações:<br><br>

                        <ul class="list-group">
                            <li class="list-group-item">- Número do contrato, da agenda, dependendo de cada caso;</li>
                            <li class="list-group-item">- Nome completo do paciente, exatamente como registrado no sistema, sem abreviações ou partes do nome omitidas;</li>
                            <li class="list-group-item">- Valor de lançamento e desconto, caso necessário;</li>
                            <li class="list-group-item">- Prints e vídeos que demonstrem o problema ocorrido, incluindo os dados inseridos.</li>
                        </ul>

                        <br>Caso não seja possível fornecer essas informações, ou o assunto não for tratado pelo Sistema TI, o chamado será fechado e bloqueado para reabertura.<br><br>
                        Atenciosamente,<br>
                        Equipe de Suporte ao Sistema
                    </div>
                `);
            } else {
                $('.js-internal-tickets-change-category-extra-info').addClass('d-none');
            }
        });

        // detecta modal fechando modal-internal-tickets-create
        $(document).on('hidden.bs.modal', '#modal-internal-tickets-create', function () {
            $('.js-internal-tickets-create-extra-info').addClass('d-none');
            $('.js-internal-feedbacks-create-extra-info').addClass('d-none');
        });

        $(document).on('click', '.js-internal-tickets-view-approve', function () {
            $('.js-internal-tickets-view-approve').addClass('disabled');
            $('.js-internal-tickets-view-reject').addClass('disabled');
            Swal.fire({
                title: 'Confirmação',
                html: 'Tem certeza que deseja aprovar este chamado?<br><br>Tipo: <b>' + self.fastActionsConfig.type + '</b>',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, aprovar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    apiCall({
                        method: 'POST',
                        endpoint: 'api/v1/internal-tickets/approve',
                        data: self.fastActionsConfig,
                        successCallback: function (res) {
                            window.toast({
                                error: res.error,
                                text: res.message
                            });
                            if (!res.error) {
                                $('#internal_tickets_view_status').html(self.getTicketStatusStyle('RESOLVIDO'));
                                self.fetchInternalTicketsList();
                                self.ticketGetAnswers(self.currentTicketId);

                                Swal.fire({
                                    title: 'Chamado aprovado com sucesso!',
                                    text: res.message,
                                    icon: 'success',
                                    showConfirmButton: true
                                });
                            } else {
                                $('.js-internal-tickets-view-approve').removeClass('disabled');
                                $('.js-internal-tickets-view-reject').removeClass('disabled');
                            }
                        },
                        errorCallback: function (err) {
                            $('.js-internal-tickets-view-approve').removeClass('disabled');
                            $('.js-internal-tickets-view-reject').removeClass('disabled');
                        }
                    });
                } else {
                    $('.js-internal-tickets-view-approve').removeClass('disabled');
                    $('.js-internal-tickets-view-reject').removeClass('disabled');
                }
            });
        });

        $(document).on('click', '.js-internal-tickets-view-reject', function () {
            $('.js-internal-tickets-view-approve').addClass('disabled');
            $('.js-internal-tickets-view-reject').addClass('disabled');
            Swal.fire({
                title: 'Confirmação',
                html: 'Tem certeza que deseja rejeitar este chamado?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim, rejeitar',
                cancelButtonText: 'Cancelar'
            }).then((result) => {
                if (result.isConfirmed) {
                    apiCall({
                        method: 'POST',
                        endpoint: 'api/v1/internal-tickets/reject',
                        data: self.fastActionsConfig,
                        successCallback: function (res) {
                            window.toast({
                                error: res.error,
                                text: res.message
                            });
                            if (!res.error) {
                                $('#internal_tickets_view_status').html(this.getTicketStatusStyle('RESOLVIDO'));
                                self.fetchInternalTicketsList();
                                self.ticketGetAnswers(self.currentTicketId);

                                Swal.fire({
                                    title: 'Chamado rejeitado com sucesso!',
                                    text: res.message,
                                    icon: 'success',
                                    showConfirmButton: true
                                });
                            } else {
                                $('.js-internal-tickets-view-approve').removeClass('disabled');
                                $('.js-internal-tickets-view-reject').removeClass('disabled');
                            }
                        },
                        errorCallback: function (err) {
                            $('.js-internal-tickets-view-approve').removeClass('disabled');
                            $('.js-internal-tickets-view-reject').removeClass('disabled');
                        }
                    });
                }
            });
        });
    }

    createInternalTicket() {
        let self = this;

        let formClass = self.isFeedbackPage ? '.js-internal-feedbacks-create-form' : '.js-internal-tickets-create-form';

        $(formClass).block(window._loader.loading);
        $(formClass).find('input[type="submit"]').prop('disabled', true);
        let data = new FormData(document.getElementsByClassName(formClass.slice(1))[0]);
        let teamList = $('#internal_tickets_create_type option:selected').data('teamlist');

        if (self.isFeedbackPage) {
            data.append('internal_ticket_is_feedback', true);
        }

        Swal.fire({
            title: 'Confirmação',
            html: self.isFeedbackPage ? `O feedback será criado para ${data.get('internal_tickets_create_user')}, ok?` : 'O chamado será direcionado para o setor de <b>' + getInternalTicketCategoryType(data.get('internal_tickets_create_type')) + '</b>.<br><br>Responsáveis: <b>' + (teamList) + '</b>',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, criar ' + (self.isFeedbackPage ? 'feedback' : 'chamado') + '',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                apiCall({
                    method: 'POST',
                    endpoint: 'api/v1/internal-tickets/create',
                    data: data,
                    processData: false,
                    contentType: false,
                    successCallback: function (res) {
                        $(formClass).find('input[type="submit"]').prop('disabled', false);
                        $(formClass).unblock();
                        if (!res.error) {
                            window.toast({
                                text: res.message
                            });
                            if (self.isFeedbackPage)
                                $('#modal-internal-feedbacks-create').modal('hide');
                            else
                                $('#modal-internal-tickets-create').modal('hide');

                            $(formClass).trigger('reset');
                            $('.js-internal-tickets-create-extra-info').addClass('d-none');
                            self.fetchInternalTicketsList();
                        } else {
                            window.toast({
                                error: res.error,
                                text: res.message
                            })
                        }
                    },
                    errorCallback: function () {
                        $(formClass).find('input[type="submit"]').prop('disabled', false);
                        $(formClass).unblock();
                    }
                });
            } else {
                $(formClass).find('input[type="submit"]').prop('disabled', false);
                $(formClass).unblock();
            }
        });
    }

    updateInternalTicket() {
        let self = this;
        let data = $('.js-courtesy-edit-form').serializeArray();

        $(".js-courtesy-edit-form").block(window._loader.loading);
        $('.js-courtesy-edit-form').find('input[type="submit"]').prop('disabled', true);

        apiCall({
            method: 'POST',
            endpoint: 'api/v1/courtesy/update',
            data: data,
            successCallback: function (res) {
                $('.js-courtesy-edit-form').find('input[type="submit"]').prop('disabled', false);
                $(".js-courtesy-edit-form").unblock();
                if (!res.error) {
                    window.toast({
                        text: res.message
                    });
                    $('#courtesy_edit_customer').val(null).trigger('change');
                    $('#modal-courtesy-edit').modal('hide');
                    $('.js-courtesy-edit-form').trigger('reset');
                    self.fetchInternalTicketsList();
                } else {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })
                }
            },
            errorCallback: function (err) {
                $('.js-courtesy-edit-form').find('input[type="submit"]').prop('disabled', false);
                $(".js-courtesy-edit-form").unblock();
            }
        });
    }

    viewInternalTicket(ticketData) {
        this.currentTicketId = ticketData.ID;

        $('#internal_tickets_view_id').val(this.currentTicketId);
        $('#internal_tickets_view_branch').val(ticketData.FILIAL);
        $('#internal_tickets_view_title').html(ticketData.TITULO);
        $('#internal_tickets_view_category').val(getInternalTicketCategoryType(ticketData.CATEGORIA_ID));
        $('#internal_tickets_view_description').html(ticketData.CONTEUDO);
        $('#internal_tickets_view_status').html(this.getTicketStatusStyle(ticketData.STATUS));
        $('#internal_tickets_view_data_solicitacao').val(moment(ticketData.DATA_SOLICITACAO).format('DD/MM/YYYY HH:mm:ss'));
        $('#internal_tickets_view_data_expiracao').val(moment(ticketData.DATA_EXPIRACAO).format('DD/MM/YYYY HH:mm:ss'));
        $('#internal_tickets_view_solicitante').val(ticketData.SOLICITANTE);

        $('.js-internal-tickets-view-id').html(ticketData.ID);
        $('.js-internal-tickets-view-requester').html(ticketData.SOLICITANTE);

        let anexos = ticketData.ANEXOS.split(',');
        let anexosHtml = '<b>Não possui anexo.</b>';
        if (anexos.length > 0) {
            anexosHtml = '';
            anexos.forEach(anexo => {
                if (anexo !== '') {
                    anexosHtml += `<a href="https://thequiro.clinicasajustar.com.br/view-attachment-tickets.php?filename=${anexo}" target="_blank">${anexo}</a><br>`;
                }
            });
        }
        $('.js-internal-tickets-view-attachments').html(anexosHtml);

        $(`.js-internal-ticket-${this.currentTicketId}`).css('background', 'none');

        if ($(`.js-internal-ticket-notification-${this.currentTicketId}`).length > 0) {
            $(`.js-internal-ticket-notification-${this.currentTicketId}`).remove();
            if ($('.vertical-time-simple').children().length === 0) {
                toggleNotificationState(0);
            }
        }

        $('#modal-internal-tickets-view').modal('show');

        this.maskTicketAsRead(this.currentTicketId);
        this.ticketGetAnswers(this.currentTicketId);
        this.ticketEasyAnswerActionsByResponsibles(ticketData);
    }

    ticketEasyAnswerActionsByResponsibles(ticketData) {
        console.log('ticketData', ticketData);
        let content = ticketData.CONTEUDO.toLowerCase();

        this.fastActionsConfig = {
            type: '',
            data: {
                ticketId: ticketData.ID
            }
        };

        // check if current user is responsible for the ticket category
        let isResponsible = false;
        let responsibleList = [];

        // get responsible list from ticket category
        window._sessionData.internalTicketsCategories.forEach(category => {
            if (category.ID === ticketData.CATEGORIA_ID) {
                responsibleList = category.RESPONSAVEIS.split(',');
            }
        });

        // check if current user is responsible for the ticket
        responsibleList.forEach(responsible => {
            if (responsible === window._sessionData.userId) {
                isResponsible = true;
            }
        });

        if (isResponsible &&
            (content.includes('segue o comprovante de reavaliação do contrato') || content.includes('segue a solicitação de cortesia para o paciente') || content.includes('segue a solicitação de upgrade anual para o paciente'))
            && ticketData.IS_APPROVED === 0 && ticketData.IS_REJECTED === 0
            && ticketData.STATUS !== 'RESOLVIDO'
            && (userHasRole('ADMIN') || userHasRole('ADMIN_ASSISTANT'))
        ) { // remove ! from "!isResponsible" in production
            $('.js-internal-tickets-view-approve').removeClass('d-none');
            $('.js-internal-tickets-view-reject').removeClass('d-none');
            if (ticketData.IS_APPROVED === 0 && ticketData.IS_REJECTED === 0) {
                $('.js-internal-tickets-view-approve').removeClass('disabled');
                $('.js-internal-tickets-view-reject').removeClass('disabled');
            } else {
                $('.js-internal-tickets-view-approve').addClass('disabled');
                $('.js-internal-tickets-view-reject').addClass('disabled');
            }
            // check if content contains any of the easy actions
            console.log('isResponsible', isResponsible, content);
            if (content.includes('segue o comprovante de reavaliação do contrato')) {
                console.log('é reavaliação de contrato');
                this.fastActionsConfig.type = 'reavaliacao_contrato';

                let findContractId = content.match(/contrato (\d+)/);
                if (findContractId) {
                    this.fastActionsConfig.data.contractId = findContractId[1];
                }

                console.log('this.fastActionsConfig', this.fastActionsConfig);
            } else if (content.includes('segue a solicitação de cortesia para o paciente')) {
                console.log('é solicitação de cortesia');

                let findPatientId = content.match(/paciente: (\d+)/);
                let findDate = content.match(/data do atendimento: (\d+)-(\d+)-(\d+)/); // format Y-m-d
                let findObservation = content.match(/observação: (.+)/);
                let findIsIndividualSessionOrCourtesy = content.match(/é sessão individual\/avaliação ou contrato: (s|c)/);
                let findServiceOrPlanId = content.match(/serviço\/plano: \(id:\s*(\d+)\)/); // Inside (id: X)

                this.fastActionsConfig.type = 'solicitacao_cortesia';

                if (findPatientId) {
                    this.fastActionsConfig.data.patientId = findPatientId[1];
                }

                if (findDate) {
                    this.fastActionsConfig.data.date = `${findDate[1]}-${findDate[2]}-${findDate[3]}`;
                }

                if (findObservation) {
                    this.fastActionsConfig.data.observation = findObservation[1];
                }

                if (findIsIndividualSessionOrCourtesy) {
                    this.fastActionsConfig.data.isIndividualSessionOrCourtesy = findIsIndividualSessionOrCourtesy[1];
                }

                if (findServiceOrPlanId) {
                    this.fastActionsConfig.data.serviceOrPlanId = findServiceOrPlanId[1];
                }

                console.log('findIsIndividualSessionOrCourtesy', findIsIndividualSessionOrCourtesy);
                console.log('findServiceOrPlanId', findServiceOrPlanId);
                console.log('this.fastActionsConfig', this.fastActionsConfig);
            } else if (content.includes('segue a solicitação de upgrade anual para o paciente')) {
                console.log('é solicitação de upgrade anual');

                let findContractId = content.match(/contrato original: (\d+)/);
                let paidValue = content.match(/valor pago pelo upgrade: ([\d,\.]+)/);
                let sessionValue = content.match(/valor por sessão: ([\d,\.]+)/);
                let includedSessions = content.match(/qtd de sessões que serão incluídas: (\d+)/);

                this.fastActionsConfig.type = 'solicitacao_upgrade_anual';

                if (findContractId) {
                    this.fastActionsConfig.data.contractId = findContractId[1];
                }

                if (paidValue) {
                    let value = paidValue[1].replace(',', '.');
                    this.fastActionsConfig.data.paidValue = parseFloat(value);
                }

                if (sessionValue) {
                    let value = sessionValue[1].replace(',', '.');
                    this.fastActionsConfig.data.sessionValue = parseFloat(value);
                }

                if (includedSessions) {
                    this.fastActionsConfig.data.includedSessions = includedSessions[1];
                }

                console.log('this.fastActionsConfig', this.fastActionsConfig);
            }
        } else {
            $('.js-internal-tickets-view-approve').addClass('d-none');
            $('.js-internal-tickets-view-reject').addClass('d-none');
        }

        console.log('isResponsible', isResponsible);
        console.log('responsibleList', responsibleList);
    }

    viewInteralTicketReplyModal() {
        $(".js-internal-tickets-answer-form").trigger('reset');
        $('#modal-internal-tickets-answer').modal('show');
    }

    answerInternalTicket(data) {
        let self = this;
        $(".js-internal-tickets-answer-form").block(window._loader.loading);
        $('.js-internal-tickets-answer-form').find('input[type="submit"]').prop('disabled', true);

        apiCall({
            method: 'POST',
            endpoint: 'api/v1/internal-tickets/answer',
            data: data,
            processData: false,
            contentType: false,
            successCallback: function (res) {
                $('.js-internal-tickets-answer-form').find('input[type="submit"]').prop('disabled', false);
                $(".js-internal-tickets-answer-form").unblock();
                if (!res.error) {
                    window.toast({
                        text: res.message
                    });
                    $('#modal-internal-tickets-answer').modal('hide');
                    $('.js-internal-tickets-answer-form').trigger('reset');
                    self.fetchInternalTicketsList();
                    self.ticketGetAnswers(self.currentTicketId);
                } else {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })
                }
            },
            errorCallback: function (err) {
                $('.js-internal-tickets-answer-form').find('input[type="submit"]').prop('disabled', false);
                $(".js-internal-tickets-answer-form").unblock();
            }
        });
    }

    maskTicketAsRead(ticketId) {
        apiCall({
            method: 'POST',
            endpoint: 'api/v1/internal-tickets/mark-as-read',
            data: {
                ticketId: ticketId
            },
            successCallback: function (res) {
                if (!res.error) {
                    $(`.js-internal-ticket-${ticketId}`).css('background', 'none');
                } else {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })
                }
            },
            errorCallback: function (err) {
                $(".modal-edit-patient-dialog").unblock();
            }
        });
    }

    ticketGetAnswers(ticketId) {
        $('.js-internal-tickets-view-replies').html('Carregando...');
        let self = this;
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/internal-tickets/answers',
            data: {
                ticketId: ticketId
            },
            successCallback: function (res) {
                if (!res.error) {
                    self.renderTicketAnswers(res.data);
                } else {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })
                }
            },
            errorCallback: function (err) {
                $(".modal-edit-patient-dialog").unblock();
            }
        });
    }

    renderTicketAnswers(answers) {
        let html = '';
        answers.forEach(answer => {
            let anexosHtml = '';

            if (answer.ANEXOS) {
                let anexos = answer.ANEXOS.split(',');
                anexos.forEach(anexo => {
                    anexosHtml += `<a href="https://thequiro.clinicasajustar.com.br/view-attachment-tickets.php?filename=${anexo}" target="_blank">${anexo}</a><br>`;
                });
            }

            html += `
            <div class="ticket-item mt-2">
                <div class="ticket-body ${anexosHtml !== '' ? 'mb-1' : ''}">
                    <p class="mb-1">Postado por <strong>${answer.USUARIO}</strong> em ${moment(answer.DATA_RESPOSTA).format("DD/MM/YYYY HH:mm:ss")}</p>
                    ${answer.RESPOSTA}
                </div>
                <!-- anexos -->
                <div class="ticket-attachments">
                    ${anexosHtml !== '' ? '<strong>Anexos:</strong><br>' : ''}
                    ${anexosHtml}
                </div>
            </div>`;
        });
        if (answers.length === 0) {
            html = 'Nenhuma resposta encontrada.';
        }
        $('.js-internal-tickets-view-replies').html(html);
    }

    getTicketStatusStyle(status) {
        let style = '';
        switch (status) {
            case 'ABERTO':
                style = '<span style="display: inline-block; padding: 5px 10px; background: grey; color: #FFF; border-radius: 4px;">ABERTO</span>';
                break;
            case 'EM ANDAMENTO':
                style = '<span style="display: inline-block; padding: 5px 10px; background: #fff3cd; color: #856404; border-radius: 4px;">EM ANDAMENTO</span>';
                break;
            case 'RESOLVIDO':
                style = '<span style="display: inline-block; padding: 5px 10px; background: #d4edda; color: #155724; border-radius: 4px;">RESOLVIDO</span>';
                break;
            case 'FECHADO':
                style = '<span style="display: inline-block; padding: 5px 10px; background: #c8d6e5; color: #004085; border-radius: 4px;">FECHADO</span>';
                break;
            case 'AGUARDANDO SOLICITANTE':
                style = '<span style="display: inline-block; padding: 5px 10px; background: #fff3cd; color: #856404; border-radius: 4px;">AGUARDANDO SOLICITANTE</span>';
                break;
            case 'AGUARDANDO RESPOSTA':
                style = '<span style="display: inline-block; padding: 5px 10px; background: #fff3cd; color: #856404; border-radius: 4px;">AGUARDANDO RESPOSTA</span>';
                break;
            case 'ATRASADO':
                style = '<span style="display: inline-block; padding: 5px 10px; background: red; color: #FFF; border-radius: 4px;">ATRASADO</span>';
                break;
        }
        return style;
    }

    markAllAsRead() {
        apiCall({
            method: 'POST',
            endpoint: 'api/v1/internal-tickets/mark-all-as-read',
            successCallback: function (res) {
                if (!res.error) {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })
                }
            },
            errorCallback: function (err) {
                $(".modal-edit-patient-dialog").unblock();
            }
        });
    }
}